module.exports = __webpack_public_path__ + "static/media/MHRM39N0013.ba91d145.svg";